<script setup lang="ts">
defineOptions({name: 'LoginFormField'});

defineProps<{
    label: string;
    htmlFor: string;
    error?: string;
}>();
</script>

<template>
    <div class="login-field">
        <label :for="htmlFor" class="login-field-label">{{ label }}</label>
        <slot />
        <div v-if="error" class="login-field-error">{{ error }}</div>
    </div>
</template>

<style scoped>
.login-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.login-field-label {
    display: block;
    text-align: left;
    color: #6c6c6c;
    font-size: 13px;
}

.login-field-error {
    color: #c1272d;
    font-size: 12px;
    text-align: left;
}
</style>
